import React from 'react';
import Categories from '../LandingPage/Categories/Categories';;
const Cagegory = () => {
    return (
        <div>
            <div className="subcategory container">Ketegories</div>
            <Categories/>
        </div>
    );
}

export default Cagegory;
